import axios from 'axios';
import Cookies from 'js-cookie';
import localSchema from './schema.json';

export interface SectionSchema {
  sectionRefs: string;
  label: string;
  fields: Record<string, any>;
}

export const getSchema = async (): Promise<SectionSchema[]> => {
  try {
    const storeUrl = Cookies.get('storeUrl');
    if (!storeUrl) {
      console.log('No store URL found, using local schema');
      return localSchema.sections;
    }

    try {
      const response = await axios.get(`${storeUrl}api/pageschema`, {
        timeout: 5000, // 5 second timeout
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      
      if (response.data.sections && Array.isArray(response.data.sections)) {
        return response.data.sections;
      }
    } catch (apiError) {
      console.warn('API schema fetch failed, using local schema:', apiError);
    }
    
    return localSchema.sections;
  } catch (error) {
    console.error('Error in schema service:', error);
    return localSchema.sections;
  }
}; 